// extracted by mini-css-extract-plugin
export default {"padding":"activity-filters-panel_padding__IPonC","no-padding":"activity-filters-panel_no-padding__stSFA","no-task-type":"activity-filters-panel_no-task-type__vxCvX"};